import { useMemo } from "react";
import { useFormikContext } from "formik";
import useSWR from "swr";
// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";

export interface FactureLigne {
  type: string;
  label: string;
  montant_ht: number;
  taux_tva: number;
  existing: boolean;
  id_balance: number | null;
  has_facture?: boolean;
}

interface FactureLinesResponse {
  lignes: FactureLigne[];
  date_facture?: string;
  periode_start?: string;
  periode_end?: string;
}

interface FormValuesWithLignes {
  lignes?: FactureLigne[];
}

export function useFactureLines(
  tenantId: number | null,
  periode: string | null | undefined,
) {
  const axios = useAuthenticatedAxios();
  const { setFieldValue } = useFormikContext<FormValuesWithLignes>();
  const fallbackData = useMemo<FactureLinesResponse>(
    () => ({ lignes: [] }),
    [],
  );

  const { data, error, isLoading } = useSWR<FactureLinesResponse>(
    tenantId && periode ? [`tenants/${tenantId}/facture-lines`, periode] : null,
    ([url, p]: [string, string]) =>
      axios
        .get(url, { params: { periode: p } })
        .then((res: { data: FactureLinesResponse }) => res.data),
    {
      fallbackData,
      onSuccess: (d: FactureLinesResponse) => setFieldValue("lignes", d.lignes),
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return {
    lignes: data!.lignes,
    dateFacture: data!.date_facture,
    periodeStart: data!.periode_start,
    periodeEnd: data!.periode_end,
    error,
    isLoading,
  };
}
